// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3KIXd","error":"Textarea_error__1ZlSK","readonly":"Textarea_readonly__BdqUr","disabled":"Textarea_disabled__2jJtM"};